import React, { useState } from "react";
import styles from "./tabby.module.css";
import { Box, Modal, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Head from "next/head";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";



export default function Index() {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  return (
        <>


        <Head>
    <title>Witchy Tabby - Astrologer, Tarot Reader & Psychic | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Witchy Tabby, Astrologer Utah, Tarot Reader Utah, Psychic Readings, Natal Charts, Solar Return, Tarot Spreads, The Mystic Frog, Orem Psychic"
    ></meta>
    <meta
      property="og:title"
      content="Book a Reading with Witchy Tabby: Astrologer, Tarot Reader & Psychic"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/witchy-tabby_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A professional headshot of Witchy Tabby, an astrologer and tarot reader, next to an astrological wheel, representing her psychic services."
    ></meta>
    <meta
      property="og:description"
      content="Meet Witchy Tabby, a professional astrologer, tarot reader, and psychic. Offering natal chart readings, tarot spreads, and intuitive guidance to help you heal and find clarity on your path. Based in Orem, Utah."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/witchy-tabby"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/witchy-tabby_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A professional headshot of Witchy Tabby, an astrologer and tarot reader, next to an astrological wheel, representing her psychic services."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/witchy-tabby"
    ></meta>
    <meta
      name="twitter:title"
      content="Book a Reading with Witchy Tabby: Astrologer, Tarot Reader & Psychic"
    ></meta>
    <meta
      name="twitter:description"
      content="Meet Witchy Tabby, a professional astrologer, tarot reader, and psychic. Offering natal chart readings, tarot spreads, and intuitive guidance to help you heal and find clarity on your path. Based in Orem, Utah."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/witchy-tabby" />
</Head>
            <div className={styles.homeblockone}>
              {/* <!------Main Banner section-------------> */}
                <div className={styles.asmainwrapper}>
                    <div className={styles.homeblockoneleft}>
                        <span className={styles.bannerLogo}>
                            <span className={styles.logoviewlink} onClick={handleOpen}>
                                {/* <img alt="viewicon" src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                                <img src={`${process.env.cloud_url2}assets/images/viewicon.png`}/>
                            </span>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" /> */}
                            <img src={`${process.env.cloud_url2}assets/images/logobanner.webp`}/>
                        </span>
                        <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
                        <h1 data-text="INFINITE BEING">INFINITE BEING</h1>
                        <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
                        <div className={styles.bannerboxtxt}>
                            <p> </p>
                        </div>
                    </div>
                </div>
            </div>

            <MysteryBannerNew/>
            <div className={styles.CM_Block1}>
                <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                    <span className={styles.column}>
                        <div className={`${styles.col12} ${styles.bgifive}`}>
                            <h1>WITCHY TABBY</h1>
                            <p>Astrologer - Tarot Reader - Psychic</p>
                        </div>
                    </span>
                </div>
                <div className={styles.common_width}>

                    <div className={`${styles.CM_components_main} ${styles.CMcompo1}`}>
                        <div className={styles.CM_Compo_image}>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/witchy_tabby/WT_B1_img1.webp" /> */}
                            <img src={`${process.env.cloud_url}witchy_tabby/WT_B1_img1.webp`}/>
                        </div>
                        <div className={styles.CM_Compo_content}>
                                <div className={styles.border_box}></div>
                            <div className={styles.CM_Compo_content_text}>
                                <h3>ABOUT ME</h3>
                                <p>I am a professional astrologer, tarot reader, and psychic who uses tarot and astrology to focus my gifts. I have two astrological certifications, have read over 5000 charts, and am contracted as an astrology/tarot reader at <span> The Mystic Frog </span> in Orem, Utah on Tuesdays from 12-7p. I am a quarterly contributor to The Pagan Chronicle where I create astrological articles on the current transits/themes of the quarter. I am also the marketing manager for the <span> Utah Pagan Market </span> in Orem, Utah. I combine eight years of experience, my vast knowledge, and some information from the other side to answer questions, help you heal, and guide you through your next steps. I enjoy bringing clarity to those for whom I read.</p>
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.CM_components_main} ${styles.CMcompo2}`}>
                        <div className={styles.CM_Compo_image}>
                            {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/witchy_tabby/WT_b1_img2.webp" /> */}
                            <img src={`${process.env.cloud_url}witchy_tabby/WT_b1_img2.webp`}/>
                        </div>
                        <div className={styles.CM_Compo_content}>
                                <div className={styles.border_box}></div>
                            <div className={styles.CM_Compo_content_text}>
                                <h2>Astrology</h2>
                                <p>I offer a number of astrology services including readings for natal charts, solar return readings, love and romance compatibility, career, and life path. I use lunar and solar progressions to further hone the truths of what is going on in your life. To inquire more about my services and which would be the best fit <span> contact </span> me below.</p>
                                <h2>Tarot</h2>
                                <p>Tarot readings offer a view into the future, yourself, and others. I offer a number of spreads including intuitive draw, 7 card, and celtic cross. I will help you choose which is the best based upon your needs. Please <span> contact </span> me below to schedule!</p>
                            </div>
                        </div>
                    </div>

                    
                </div>
            </div>










            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className={styles.banner_modal_main}
            >
                <Box className={styles.banner_modal_box}>
                    <Typography id="modal-modal-description" component="div" sx={{ mt: 2 }} className={styles.modal_banner}>
                        <div className={styles.sub_modal_banner}>
                            <span className={styles.close_btn} onClick={handleClose}>
                                <CloseIcon/>
                            </span>
                            <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"alt="bannerLogo"/>
                        </div>
                    </Typography>
                </Box>
            </Modal>
        </>
    );
}
